import { GridColDef } from "@mui/x-data-grid";

import { formatMoney, formatNumber, TranslationFunction } from "../utils";

/** The "Job Services" stat card value: how many were performed, and what they
 *  are worth at their current prices. */
export const formatJobServicesTotals = (
  count: number | undefined,
  value: number | undefined
): string => {
  if (count === undefined) return "-";

  return `${count} (${formatMoney(value ?? 0)})`;
};

/** A service's performances times its price, for the Top Job Services table. */
export const buildJobServiceValueColumn = (t: TranslationFunction): GridColDef => ({
  field: "value",
  headerName: t("Value (zł)"),
  width: 120,
  valueGetter: (value) => formatNumber(value),
});

/** What the services performed on one equipment are worth, for the equipment
 *  breakdown table. */
export const buildEquipmentServicesValueColumn = (
  t: TranslationFunction
): GridColDef => ({
  field: "services_value",
  headerName: t("Services Value (zł)"),
  width: 160,
  valueGetter: (value) => formatNumber(value),
});
